angular.module('leanlaw').directive('llMattersListForClient', [function () {
  return {
    restrict: 'AE',
    template: require("./views/mattersListForClient.html"),
    scope: {
      matters: "=",
      current: "=",
      matterSelected: "=?",
      initials: "=?",
      me: "="
    },
    link: scope => {
      scope.billingTypeForHumans = ({
        billing
      }) => {
        switch (billing.type) {
          case 'hours':
            return 'Hourly';
          case 'none':
            return 'Pro Bono';
          case 'contingency':
            return 'Contingency';
          case 'fixed':
            return 'Fixed Fee';
          case 'internal':
            return 'Internal';
          default:
            return '';
        }
      };
    }
  };
}]);